import _ from 'underscore';
import Promise from 'bluebird';
import { AdjustmentsUtils } from '@bingads-webui-clientcenter/entity-utils';

let newAdjustmentReasons;

/**
 * @type {reason}
 * @param {number} reason.id Adjustment reason id
 * @param {string} reason.value Adjustment reason localized value
 */

/**
 * Get the reasons from MT domainData by calling API/DomainData/AdjustmentReasonMapping
 * Returns reasons array after format them with a localized value and add the default None reason.
 * @param {object} jsDataCcRest jsData object
 * @param {object} i18n i18n
 * @returns {promise<reason[]>} The formatted reasons
 */
export const findNewAdjustmentReasons = (jsDataCcRest, i18n) => {
  if (_.isUndefined(newAdjustmentReasons)) {
    return jsDataCcRest.DomainDataAdjustmentReason.findAll().then((reasons) => {
      newAdjustmentReasons = AdjustmentsUtils.mapNewAdjustmentReasons(reasons, i18n);
      return newAdjustmentReasons;
    });
  }

  return Promise.resolve(newAdjustmentReasons);
};
